import EventsTheatrePage from "../EventsTheatrePage/EventsTheatrePage";
import EventsMusicalTheatrePage from "../EventsMusicalTheatrePage/EventsMusicalTheatrePage";
import EventsMuseumPage from "../EventsMuseumPage/EventsMuseumPage";
import EventTypesPage from "../EventTypesPage/EventTypesPage";
import GenresPage from "../GenresPage/GenresPage";
import SpheresPage from "../SpheresPage/SpheresPage";
import LocationsPage from "../LocationsPage/LocationsPage";
import CountriesPage from "../CountriesPage/CountriesPage";
import ArtistsPage from "../ArtistsPage/ArtistsPage";
import LiteraryWorksPage from "../LiteraryWorksPage/LiteraryWorksPage";
import TagsPage from "../TagsPage/TagsPage";
import RewardsPage from "../RewardsPage/RewardsPage";
import SchoolSubjectsPage from "../SchoolSubjectsPage/SchoolSubjectsPage";
import SchoolThemesPage from "../SchoolThemesPage/SchoolThemesPage";
import ArtistSuggestionsPage from "../ArtistSuggestionsPage/ArtistSuggestionsPage";
import ArtistSuggestionsStatusService from "../../API/ArtistSuggestionsStatusService";
import WeightCoefficientsPage from "../WeightCoefficientsPage/WeightCoefficientsPage";
import SurveysPage from "../SurveysPage/SurveysPage";
import VisitTypesPage from "../VisitTypesPage/VisitTypesPage";
import SubscriptionCancellationsPage from "../SubscriptionCancellationsPage/SubscriptionCancellationsPage";
import EventDraftsPage from "../EventDraftsPage/EventDraftsPage";

// TEMP: icons ✅ ❎ ⚠️ ⛔ 🥝 📌 👌 🐞 💡 🔔 🔎 🔒 🔑 🔨 🔧 🔸 🔹 🔶 🔷 🔗 🧪 🧾 ⚡ ⭐ 📎 👍 👎 ☑️ ✔️ ❌

// все имеющиеся режимы, включая специальные/скрытые
export const allModes = [
    /*{
        name: "eventsTheatre", // уникальное имя (исплользуется как идентификатор)
        title: "События (театр)", // название режима (для кнопок меню / табов)
        isInMenu: true, // виден ли режим в меню слева
        isExpandable: true, // раскрывается ли в меню в виде под-пунктов "редактировать"/"добавить"
        formComponent: null, // ссылка на компонент формы для данного режима
    },*/
    {
        // TODO: (srv) разделить query на отдельные части (для поиска по названию события и поиска по названию локации) (https://tracker.yandex.ru/KULT-145) !!! после решили, что нужен поиск только по названиям событий!
        // TODO: (srv/cli) (!) отдавать все рефы под одним именем (всегда artists, но не authors) (исходя из названия таблицы/апи) / сначала обсудить / (спросил в тг 01.05.2026)
        // TODO: (srv/cli) (!) фильтровать типы событий исходя из kultural_goal (сделать апи)
        name: "eventsTheatre", // уникальное имя (исплользуется как идентификатор)
        title: "События (театр)", // название режима (для кнопок меню / табов)
        isInMenu: true, // виден ли режим в меню слева
        isExpandable: true, // раскрывается ли в меню в виде под-пунктов "редактировать"/"добавить"
        formComponent: EventsTheatrePage,
    },
    {
        name: "eventsMusicalTheatre", // уникальное имя (исплользуется как идентификатор)
        title: "События (музык. театр)", // название режима (для кнопок меню / табов)
        isInMenu: true, // виден ли режим в меню слева
        isExpandable: true, // раскрывается ли в меню в виде под-пунктов "редактировать"/"добавить"
        formComponent: EventsMusicalTheatrePage,
    },
    {
        // TODO: ? как фильтровать темы предмета по классу, если выбрано несколько классов? -- будет расширенный фильтр по классам (https://tracker.yandex.ru/KULT-148)
        // TODO: (srv) (!) при получении/отправке артистов (авторов эксп.) не использовать role (сервер автоматически берет main_role) / сначала обсудить (спросил в тг 01.05.2026)
        name: "eventsMuseum", // уникальное имя (исплользуется как идентификатор)
        title: "События (музей)", // название режима (для кнопок меню / табов)
        isInMenu: true, // виден ли режим в меню слева
        isExpandable: true, // раскрывается ли в меню в виде под-пунктов "редактировать"/"добавить"
        formComponent: EventsMuseumPage,
    },
    {
        name: "eventDrafts",
        title: "События (музей B2B)",
        isInMenu: true,
        isExpandable: true,
        disableAddOption: true,
        formComponent: EventDraftsPage,
    },
    {
        name: "eventTypes",
        title: "Типы события",
        isInMenu: true,
        isExpandable: true,
        formComponent: EventTypesPage,
    },
    {
        name: "genres",
        title: "Жанры",
        isInMenu: true,
        isExpandable: true,
        formComponent: GenresPage,
    },
    {
        name: "spheres",
        title: "Сферы",
        isInMenu: true,
        isExpandable: true,
        formComponent: SpheresPage,
    },
    {
        name: "visitTypes",
        title: "Типы посещения (музеев)",
        isInMenu: true,
        isExpandable: true,
        formComponent: VisitTypesPage,
    },
    {
        name: "locations",
        title: "Локации",
        isInMenu: true,
        isExpandable: true,
        formComponent: LocationsPage,
    },
    {
        name: "countries",
        title: "Страны/Регионы/Города",
        isInMenu: true,
        isExpandable: true,
        formComponent: CountriesPage,
    },
    {
        name: "artists",
        title: "Деятели",
        isInMenu: true,
        isExpandable: true,
        formComponent: ArtistsPage,
    },
    {
        name: "artistSuggestions",
        title: "Деятели (заявки)",
        isInMenu: true,
        isExpandable: true,
        disableAddOption: true,
        formComponent: ArtistSuggestionsPage,
        notificationEffectFunc: (setNotificationVisible) => {

            function onStatus(total) {
                setNotificationVisible(total > 0);
            }

            onStatus(ArtistSuggestionsStatusService.getCurrentTotal());
            ArtistSuggestionsStatusService.addListener(onStatus);

            return () => {
                ArtistSuggestionsStatusService.removeListener(onStatus);
            }
        }
    },
    {
        name: "literaryWorks",
        title: "Произведения",
        isInMenu: true,
        isExpandable: true,
        formComponent: LiteraryWorksPage,
    },
    {
        name: "tags",
        title: "Теги",
        isInMenu: true,
        isExpandable: true,
        formComponent: TagsPage,
    },
    {
        name: "rewards",
        title: "Награды/Олимп./Фест.",
        isInMenu: true,
        isExpandable: true,
        formComponent: RewardsPage,
    },
    {
        name: "schoolSubjects",
        title: "Школьные предметы",
        isInMenu: true,
        isExpandable: true,
        formComponent: SchoolSubjectsPage,
    },
    {
        name: "schoolThemes",
        title: "Школьные темы",
        isInMenu: true,
        isExpandable: true,
        formComponent: SchoolThemesPage,
    },
    {
        name: "weightCoefficients",
        title: "Весовые коэффициенты",
        isInMenu: true,
        isExpandable: true,
        disableAddOption: true,
        formComponent: WeightCoefficientsPage,
    },
    {
        name: "surveys",
        title: "Опросы",
        isInMenu: true,
        isExpandable: true,
        disableAddOption: true,
        formComponent: SurveysPage,
    },
    {
        name: "subscriptionCancellations",
        title: "Отказы от подписки",
        isInMenu: true,
        isExpandable: true,
        disableAddOption: true,
        formComponent: SubscriptionCancellationsPage,
    },
    /*{
        name: "visitTypes",
        title: "⛔ Типы посещения",
        isInMenu: true,
        isExpandable: true,
        formComponent: null,
    },*/
    /*{
        name: "userInfo",
        title: "Инфо пользователя",
        isInMenu: false,
        isExpandable: false,
        formComponent: null, 
    },*/
];

export const allSubModes = [
    {
        isAdd: true,
        name: "add", // уникальное имя / идентификатор
        title: "Добавить", // название (на кнопках)
        tabTitle: "добавление" // сокращенное название (на табах браузера)
    },
    {
        isAdd: false,
        name: "edit",
        title: "Редактировать",
        tabTitle: "редактирование"
    },
];